import React from "react";
import Checkbox from "@material-ui/core/Checkbox";

type CheckBoxOptionProps = {
  checked: boolean;
  onChange: (event: any, checked: boolean) => void;
  tabIndex?: number;
  color: "default" | "primary" | "secondary";
};

const CheckBoxOption = ({
  checked,
  onChange,
  tabIndex,
  color,
}: CheckBoxOptionProps) => {
  return (
    <Checkbox
      checked={checked}
      onChange={onChange}
      color={color}
      tabIndex={tabIndex}
    />
  );
};

export default CheckBoxOption;
